<template>
  <div class="live-thumbnail-mobile position-relative">
    <img v-if="thumbnail" :src="thumbnail" :alt="video.title" role="button" class="w-100" @click="$emit('selected')" />

    <div
      :id="'live-thumbnail-mobile-container-' + video.id"
      v-else
      class="live-thumbnail-container rounded p-4"
      role="button"
      @click="$emit('selected')"
      style="z-index:10000; position:absolute; left:-99999px"
    >
      <div class="position-relative">
        <div class="row">
          <div class="col">
            <div class="position-relative text-left">
              <b-img :src="speakerImage" :alt="video.speaker.name" class="rounded-circle ml-auto shadow speaker-image" fluid />
              <b-img src="/static/img/live/live_stream_badge.png" fluid width="130px" class="live-logo-badge" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col mt-3">
            <h3 class="my-0 mt-1 video-title mt-3">{{ video.title }}</h3>
            <h5 class="my-0 mt-1 p-0 video-speaker mt-4">{{ video.speaker.name }}</h5>
            <p class="my-0 mt-1 video-content mt-3">{{ video.content }}</p>
          </div>
        </div>
        <div class="row p-1 pt-5 text-center">
          <div class="col-5 mb-2">
            <b-img src="/static/logo.png" width="130px" fluid />
          </div>
          <div class="col-6 col-sm-6 col-md-6 mb-2">
            <div class="d-flex mt-4 justify-content-center align-items-center">
              <b-img src="/static/img/live/live_clock.png" class="mb-4 mr-3" width="40px" fluid />
              <div class="text-left">
                <div class="date-text-1">
                  {{ dayOfTheWeek }}
                  <br />
                  <div class="date-text-2 pt-2 mr-4">{{ dateTime }}</div>
                </div>
                <div class="row align-items-center text-center pt-3">
                  <a class="date-text-3" href="https://www.shasilluminated.org/live">www.shasilluminated.org/live</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueAspectRatio from 'vue-aspect-ratio';
import moment from 'moment';

export default {
  props: ['video'],
  components: {
    'vue-aspect-ratio': VueAspectRatio,
  },
  mounted() {
    console.log(this.video.timing);
  },
  computed: {
    thumbnail() {
      return this.video.attachment ? this.video.attachment.url : null;
    },
    speakerImage() {
      return this.video.speaker.image ? this.video.speaker.image.url : '/static/blank_profile.jpg';
    },
    dayOfTheWeek() {
      return this.getLocalTime().format('dddd');
    },
    dateTime() {
      return this.getLocalTime().format('MMM DD - hh:mm A');
    },
  },
  methods: {
     getLocalTime(video) {
      return moment
        .utc(this.video.start)
        .local();
    },
  },
};
</script>

<style scoped lang="scss">
.live-thumbnail-container {
  width: 540px;
  height: auto;
}

.video-title {
  font-size: 30px;
  line-height: 35px;
}

.video-speaker {
  font-size: 25px;
  line-height: 19px;
}

.video-content {
  font-size: 20px;
  line-height: 25px;
}

.live-thumbnail-mobile {
  .live-badge {
    position: absolute;
    top: -1.12rem;
  }

  .speaker-image {
    width: 50%;
  }

  .live-logo-badge {
    position: absolute;
    top: 69.75%;
    left: 36.08%;
  }
  .date-text-1 {
    font-family: Inter, sans-serif;
    color: #0e32b1;
    font-weight: 800;
    font-size: 27.5px;
    line-height: 16px;
    font-stretch: expanded;
  }

  .date-text-2 {
    font-family: Inter, sans-serif;
    color: #0e32b1;
    font-weight: 800;
    font-size: 15px;
    line-height: 16px;
  }

  .date-text-3 {
    font-family: Inter, sans-serif;
    color: #0e32b1;
    font-weight: 600;
    font-size: 15px;
    line-height: 16px;
    /* identical to box height, or 145% */

    letter-spacing: -0.03em;
  }
}
</style>
